// ════════════════════════════════════════════════════════════════════════
// icons.tsx — Íconos de trazo simple para usar en <Button icon={...} />
// ════════════════════════════════════════════════════════════════════════
// Reemplazan a los emoji (🚀, etc.) que traían algunos textos de CTA — un
// emoji se ve distinto en cada sistema operativo/navegador y lee como poco
// profesional en un botón. Estos son SVG con currentColor (heredan el
// color del botón) y width/height: 1em (escalan con el tamaño de fuente),
// mismo lenguaje visual que los íconos de GraphDecoration/
// TechStackDecoration: trazo simple, sin relleno, redondeado.
// ════════════════════════════════════════════════════════════════════════

// Flecha hacia la derecha — CTAs de avance/acción ("Quiero mi Landing
// Page", "Empezar ahora", "Enviar mi proyecto").
export function ArrowRightIcon() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
      <path
        d="M3 8h10M9 4l4 4-4 4"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Rayo — credencial de migración/velocidad (Hero).
export function LightningIcon() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M13 2 4 14h7l-1 8 9-12h-7l1-8z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Check — credencial de "sin intermediarios" (Hero).
export function CheckIcon() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M20 6 9 17l-5-5"
        stroke="currentColor"
        strokeWidth={2.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Audífonos — credencial de soporte dedicado (Hero).
export function HeadsetIcon() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 18v-6a9 9 0 0 1 18 0v6"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
